import { all } from "redux-saga/effects";
import user from "sagas/user";
import jobs from "sagas/jobs";
import open from "sagas/open";
import balance from "sagas/balance";
import file from "sagas/file";
import team from "sagas/team";
import createAnimation from "sagas/createAnimation";

export default function* rootSaga(): Generator {
    yield all([
        user(),
        jobs(),
        open(),
        balance(),
        file(),
        team(),
        createAnimation(),
    ]);
}
